import React from 'react';

const FullscreenContainer = ({ ...props }: React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>) => (
  <div className="min-h-screen" {...props} />
);

export default FullscreenContainer;
